import StoriesTravelMap from "@/components/StoriesTravelMap";

/**
 * Public page: /where-our-stories-travel
 *
 * A minimalist reveal of the NaturePulse SpLink scan feed — every QR
 * scan and short-link click a reader has made on any NaturePulse story
 * pinned to its country of origin. Live data, refreshed every minute.
 */
export default function WhereOurStoriesTravel() {
  return (
    <main className="min-h-screen pt-24 pb-24" data-testid="where-our-stories-travel-page">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="font-mono-tech text-[10px] tracking-[0.35em] uppercase text-[color:var(--np-brand,#B85F2A)]">
          NaturePulse · Reach
        </div>
        <h1 className="mt-4 font-serif-display text-5xl md:text-7xl leading-[0.9] tracking-tighter max-w-4xl">
          Where our stories travel.
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-[#3A3830]">
          Every QR code and short link we mint is a story leaving the page.
          Each scan is a moment a reader picked up the thread — in a park,
          on a poster, in a classroom, in a WhatsApp chat. This map is
          those moments, drawn live.
        </p>
      </div>

      <StoriesTravelMap variant="hero" days={30} />

      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <FootnoteCard
            title="Privacy-first"
            body="We record country and city — never IP, name, or device fingerprint. Individual scans are aggregated within a minute of arrival."
          />
          <FootnoteCard
            title="Live source"
            body="Data streams in from SpLink.pro webhooks the moment a QR is scanned or a shortened link is clicked. Aggregate refreshes every 60 seconds."
          />
          <FootnoteCard
            title="Rolling window"
            body="This view shows the last 30 days. Older activity fades from the map but stays counted in the total below the chart."
          />
        </div>
      </div>
    </main>
  );
}

function FootnoteCard({ title, body }) {
  return (
    <div className="rounded-2xl border border-black/10 bg-white p-5">
      <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[color:var(--np-brand,#B85F2A)]">
        {title}
      </div>
      <p className="mt-2 text-sm text-[#3A3830] leading-relaxed">{body}</p>
    </div>
  );
}
